import { useMultiTierCheckout } from '../../context';
import PaymentOption from './components/PaymentOption';

const AFFIRM_MIN_AMOUNT = 50;

const CURRENCY_COUNTRY = {
  CAD: 'CA',
  USD: 'US'
};

const PaymentOptions = ({
  cards,
  loading,
  selectedCardId,
  purchaseCurrency,
  addCard,
  navigateToSelectPaymentMethod
}) => {
  const {
    data: { checkoutSession, paymentMethod },
    selectBuyNowPayLaterAndSave
  } = useMultiTierCheckout();

  const defaultCard = cards?.find((card) => card.default);
  const card = selectedCardId
    ? cards?.find((card) => card?._id === selectedCardId)
    : defaultCard;

  const handleKlarnaClick = () => {
    selectBuyNowPayLaterAndSave('klarna');
  };

  const handleAffirmClick = () => {
    selectBuyNowPayLaterAndSave('affirm');
  };

  const handleCreditCardClick = () => {
    if (!card) {
      addCard();
    } else {
      selectBuyNowPayLaterAndSave(null);
    }
  };

  const handleChangeCreditCardClick = (
    ev: React.MouseEvent<HTMLButtonElement>
  ) => {
    ev.stopPropagation();
    navigateToSelectPaymentMethod();
  };

  return (
    <>
      <ul className="flex flex-col gap-4">
        <li>
          <PaymentOption
            icon={<img src="/img/icons/visa.svg" />}
            title={card ? `Card ending in ${card?.last4}` : 'Add Card'}
            onPress={!card ? addCard : handleCreditCardClick}
            disabled={loading}
            selected={
              paymentMethod.selectedCard.value &&
              !paymentMethod.selectedBuyNowPayLater.value
            }
          >
            {card && (
              <button
                type="button"
                className="text-sm font-normal text-primary-400 hover:text-primary-700 pr-4"
                disabled={loading}
                onClick={handleChangeCreditCardClick}
              >
                Change Card
              </button>
            )}
          </PaymentOption>
        </li>
        <li>
          <PaymentOption
            icon={<img src="/img/icons/klarna.svg" />}
            title="Pay in 4 with Klarna"
            selectedSubtitle="Fees have been adjusted"
            disabled={loading}
            onPress={handleKlarnaClick}
            selected={paymentMethod.selectedBuyNowPayLater.value === 'klarna'}
          />
        </li>
        <li>
          <PaymentOption
            icon={<img src="/img/icons/affirm.svg" />}
            disabled={
              loading ||
              checkoutSession.checkoutSession?.total < AFFIRM_MIN_AMOUNT
            }
            title={`Pay over time with Affirm ($${AFFIRM_MIN_AMOUNT}+)`}
            selectedSubtitle="Fees have been adjusted"
            onPress={handleAffirmClick}
            selected={paymentMethod.selectedBuyNowPayLater.value === 'affirm'}
          />
        </li>
      </ul>

      {card && CURRENCY_COUNTRY[purchaseCurrency] !== card.country && (
        <div className="text-small text-center font-normal text-gray-500 mt-1">
          Note: Extra fees may apply with international cards.
        </div>
      )}
    </>
  );
};

export default PaymentOptions;
